module.exports = "/src/views/player/help/images/lawn2.jpg";